import React from 'react';
import { Link } from "react-router-dom";

import menu1Icon from "../../../img/icon/icon-menu-01.svg";
import menu2Icon from "../../../img/icon/icon-menu-02.svg";
import menu3Icon from "../../../img/icon/icon-menu-03.svg";
import menu4Icon from "../../../img/icon/icon-menu-04.svg";
import menu1onIcon from "../../../img/icon/icon-menu-01-on.svg";
import menu2onIcon from "../../../img/icon/icon-menu-02-on.svg";
import menu3onIcon from "../../../img/icon/icon-menu-03-on.svg";
import menu4onIcon from "../../../img/icon/icon-menu-04-on.svg";

const Footer = ({varCurrentPage}) => {
  return (
    <div id="gnb-menu-wrap">
      <ul className="gnb-menu">
        <li>
          <Link to="/Parents/ClassList" className={varCurrentPage===1?"link active":"link"}>
            <div className="icon"><img src={varCurrentPage===1?menu1onIcon:menu1Icon} alt=""/></div>
            <div className="label">클래스</div>				
          </Link>
        </li>
        <li>
          <Link to="/Parents/Analysis" className={varCurrentPage===2?"link active":"link"}>
            <div className="icon"><img src={varCurrentPage===2?menu2onIcon:menu2Icon} alt=""/></div>
            <div className="label">발달분석/평가</div>				
          </Link>
        </li>
        <li>
          <Link to="/Parents/ReinForce" className={varCurrentPage===3?"link active":"link"}>
            <div className="icon"><img src={varCurrentPage===3?menu3onIcon:menu3Icon} alt=""/></div>
            <div className="label">보강/참여수업</div>				
          </Link>
        </li>
        <li>
          <Link to="/Parents/MyPage" className={varCurrentPage===4?"link active":"link"}>
            <div className="icon"><img src={varCurrentPage===4?menu4onIcon:menu4Icon} alt=""/></div>
            <div className="label">더보기</div>				
          </Link>
        </li>
      </ul>
    </div>
  )
}
export default Footer;